export enum RuleStatus
    {
        Active,
        Pending,
        Inactive

    };